import type { ReceivePaymentRequest } from '@vy/api-definition';
import { useMutation, useQueryClient, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../services/api';
import {
  invalidateInvoicesQueries,
  invalidatePaymentsQueries,
} from '../utils/query-invalidation';

export function useReceivePayment(options?: UseMutationOptions<void, unknown, ReceivePaymentRequest>) {
  const queryClient = useQueryClient();

  return useMutation(
    (receivePaymentRequest) => {
      const api = getPrivateApi();

      return api.receivePayment({ receivePaymentRequest });
    },
    {
      onSuccess: async () => {
        await Promise.all([
          invalidateInvoicesQueries(queryClient),
          invalidatePaymentsQueries(queryClient),
        ]);
      },
      ...options,
    },
  );
}
